var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18432 21C3.88746 21 3.59061 20.7375 3.59061 20.3V15.75H1.9579C1.06733 15.75 0.325195 14.875 0.325195 13.825V7.175C0.325195 6.125 1.06733 5.25 1.9579 5.25H3.59061V1.925C3.66482 0.875 4.40696 0 5.37174 0H13.1642C14.0548 0 14.7969 0.875 14.7969 1.925V5.25H16.4296C17.3944 5.25 18.1365 6.125 18.1365 7.175V13.7375C18.1365 14.7875 17.3944 15.6625 16.5038 15.6625H14.8711V20.2125C14.8711 20.5625 14.6485 20.9125 14.2774 20.9125H4.18432V21ZM13.6837 19.6875V11.8125H4.77803V19.6875H13.6837ZM16.5038 14.4375C16.8007 14.4375 17.0975 14.175 17.0975 13.7375V7.175C17.0975 6.825 16.8749 6.475 16.5038 6.475H2.03212C1.73526 6.475 1.4384 6.7375 1.4384 7.175V13.7375C1.4384 14.0875 1.66105 14.4375 2.03212 14.4375H3.66482V11.1125C3.66482 10.7625 3.88746 10.4125 4.25853 10.4125H14.2774C14.5743 10.4125 14.8711 10.675 14.8711 11.1125V14.4375H16.5038ZM13.6837 5.25V1.925C13.6837 1.575 13.4611 1.225 13.09 1.225H5.37174C5.00067 1.3125 4.77803 1.575 4.77803 1.925V5.25H13.6837Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14547 9.1875C2.7744 9.1875 2.55176 8.925 2.55176 8.575C2.55176 8.225 2.7744 7.875 3.14547 7.875H4.25868C4.55553 7.875 4.77818 8.1375 4.77818 8.575C4.77818 9.0125 4.55553 9.275 4.18446 9.275H3.14547V9.1875Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41061 14.4375C6.11375 14.4375 5.81689 14.175 5.81689 13.7375C5.81689 13.3 6.11375 13.125 6.41061 13.125H11.9766C12.2735 13.125 12.5704 13.3875 12.5704 13.825C12.5704 14.2625 12.3477 14.525 11.9766 14.525H6.41061V14.4375Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41061 17.0625C6.11375 17.0625 5.81689 16.8 5.81689 16.3625C5.81689 15.925 6.11375 15.75 6.41061 15.75H10.2697C10.5666 15.75 10.8634 16.0125 10.8634 16.45C10.8634 16.8875 10.6408 17.15 10.2697 17.15H6.41061V17.0625Z",
    fill: "#0E5DAB",
    fillOpacity: 0.97008
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8113,
    height: 21,
    fill: "white",
    transform: "translate(0.325195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.855b99d9.svg";
export { ForwardRef as ReactComponent };